import { render } from "./BackToWorkButton.vue?vue&type=template&id=432b9614"
import script from "./BackToWorkButton.vue?vue&type=script&lang=js"
export * from "./BackToWorkButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__